
  import { defineComponent } from 'vue';

  import Tooltip from '@/common/ui/Tooltip.vue';

  export default defineComponent({
    name: 'StatisticsPortalVisitsCountNameCell',
    components: {
      Tooltip,
    },
    props: {
      value: {
        type: String,
        required: true,
      },
    },
    computed: {
      showTooltip(): boolean {
        return this.value?.toLowerCase() === 'загранаппарат';
      },
      tooltipText(): string {
        return 'Количество посещений по группе загранаппарат рассчитывается методом суммирования посещений всех уникальных пользователей данной группы';
      },
    },
  });
